import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";

/*
 *  Footer section
 *    
 *
 *  Version:
 *    1.0.0 - 2020/10/20
 */
import { initAccordion } from '../../objects/accordion/accordion';
var FOOTER_CONTAINER = '[data-footer]';
var BACK_BUTTON = '[data-back-button]';
var ACCORDION_CONTAINER = '[data-accordion-footer-container]'; //const accordionBody: HTMLElement | null = document.querySelector('[data-accordion-footer-container]');

document.querySelectorAll(FOOTER_CONTAINER).forEach(function (footer) {
  //const button = document.querySelector<HTMLButtonElement>(BACK_BUTTON);
  var accordionBody = footer.querySelector(ACCORDION_CONTAINER);

  var onDetectCustomerPosted = function onDetectCustomerPosted() {
    if (window.location.search.indexOf('customer_posted=true') != -1) {
      setTimeout(function () {
        window.scrollTo(0, document.body.scrollHeight);
      }, 700);
    }
  };

  initAccordion(accordionBody);
  onDetectCustomerPosted();
});